import { AttendeeAgeStatusService } from 'domain/services/AttendeeAgeStatusService/AttendeeAgeStatusService'
import { LiveImportAttendeeFrontReadService } from 'live/Import/LiveImportAttendeeFrontReadService'
import { LiveImportAttendeeRepository } from 'live/Import/LiveImportAttendeeRepository'
import { LiveImportAttendeeRowService } from 'live/Import/LiveImportAttendeeRowService'
import { LiveFrontCartService } from './Cart/LiveFrontCartService'
import { medusaClient } from './liveIsomorphicInstances'

export const liveAttendeeAgeStatusService = new AttendeeAgeStatusService()

export const liveFrontCartService = new LiveFrontCartService(medusaClient)

const liveImportAttendeeRepository = new LiveImportAttendeeRepository()
export const liveImportAttendeeRowService = new LiveImportAttendeeRowService(
  liveImportAttendeeRepository
)

export const liveImportAttendeeFrontReadService =
  new LiveImportAttendeeFrontReadService()
